/* eslint-disable no-console */
import RefreshIcon from '@mui/icons-material/Refresh';
import { Stack, TextField, Typography } from '@mui/material';
import React, { useContext } from 'react';
import { LanguageContext } from '../../../../../../libs/Context';
import CustomSwitch from '../../../../../BusinessSettings/Components/BussinessCertification/components/CustomSwitch';
import { generateRandomFourDigitNumber } from '../../../../../../libs/HelperContent';

const Password = (props) =>
{
	const { openPassword, setOpenPassword, data, handleSet } = props;
	const { language } = useContext(LanguageContext);

	const MAX_PASSWORD_LENGTH = 20;

	const handleToggle = (isChecked) =>
	{
		setOpenPassword(isChecked);
		handleSet('meetingPassword', isChecked ? generateRandomFourDigitNumber() : '');
	};

	const handleChange = (e) =>
	{
		const value = e.target.value.slice(0, MAX_PASSWORD_LENGTH);

		handleSet('meetingPassword', value.trim());
	};

	return (
		<>
			<CustomSwitch
				toggleEnabled={openPassword}
				handleToggleChange={(e) => handleToggle(e.target.checked)}
			/>
			<Typography>{language.password}</Typography>
			{openPassword &&
			<Stack direction={'row'} display={'flex'} alignItems={'center'} pl='var(--pixel8)'>
				<Stack sx={{ width: '65%' }}>
					<TextField
						fullWidth
						placeholder={'Enter Password'}
						size='small'
						value={data?.meetingPassword}
						onChange={handleChange}
						style={{ paddingRight: 'var(--pixel4)' }}
					/>
				</Stack>
				<RefreshIcon sx={{ color: 'var(--primaryColor)' }} style={{ cursor: 'pointer' }} onClick={() => handleToggle(true)}/>
			</Stack>
			}
		</>
	);
};

export default Password;